import { FC } from 'react';
import { IProductList } from '../../../types/orders';
import { formatShortDate } from '../../../utils/formatDatesAndHours';
import { formatOrderAmount } from '../../../utils/orders';
import './OrderInfoTable.scss';

interface IOrderInfoTableProps {
  data: IProductList;
}

interface IOrderInfoFieldProps {
  label: string;
  value: string;
  isFirstField?: boolean;
}

const OrderInfoField: FC<IOrderInfoFieldProps> = ({ label, value, isFirstField = false }) => {
  return (
    <div className="orderInfoTableField">
      <div className="orderInfoTableLabel" title={label}>
        {label}
      </div>
      <div
        className={`orderInfoTableValue ${isFirstField ? 'orderInfoTableValueFirst' : ''}`}
        title={value}
      >
        {value}
      </div>
    </div>
  );
};

const OrderInfoTable: FC<IOrderInfoTableProps> = ({ data }) => {
  const {
    orderId,
    organizationName,
    createdAt,
    countriesShipments,
    paymentType,
    total,
    totalUsd,
    currency
  } = data;

  const noDateMessage = 'Sin fecha';
  const noInformationMessage = 'Sin información';

  const formattedDate = createdAt ? formatShortDate(createdAt)?.onlyDate || noDateMessage : noDateMessage;
  const destinationCountry = countriesShipments?.[0]?.name || noInformationMessage;
  const paymentMethod = paymentType || noInformationMessage;
  const orderNumber = orderId ? `N°${orderId}` : noInformationMessage;
  const clientName = organizationName || noInformationMessage;
  const amount = formatOrderAmount(total, totalUsd, currency);

  return (
    <div className="orderInfoTable">
      <div className="orderInfoTableRow">
        <OrderInfoField label="Orden:" value={orderNumber} isFirstField />
        <OrderInfoField label="Cliente:" value={clientName} />
        <OrderInfoField label="Solicitada:" value={formattedDate} />
        <OrderInfoField label="Destino:" value={destinationCountry} />
        <OrderInfoField label="Método de pago:" value={paymentMethod} />
        <OrderInfoField label="Monto:" value={amount} />
      </div>
    </div>
  );
};

export default OrderInfoTable;
